export default __webpack_public_path__ + "static/media/a876beb7-9742-4fe6-bffa-058278e65fad.5a236fe1.jpg";